export enum GeneralInvitationErrorCode {
    API_INSUFFICIENT_PERMISSIONS = 'api.context.permissions.app_error',
    API_UNAVAILABLE_GUEST_ROLE = 'api.team.invite_restricted_guests.unavailable_role.app_error',
    API_UNAVAILABLE_GUEST_PLUS_ROLE = 'api.team.invite_guests.unavailable_role.app_error',
}
